import Editor from './editor';

/**
 * Interface extending HTMLElement to include custom properties for event listeners and range.
 */
interface ExtendedHTMLElement extends HTMLElement {
  inputListener?: EventListenerOrEventListenerObject;
  keydownListener?: EventListenerOrEventListenerObject;
  clickListener?: EventListenerOrEventListenerObject;
  pasteListener?: EventListenerOrEventListenerObject;
  selectionChangeListener?: EventListenerOrEventListenerObject;
  range?: Range;
}

/**
 * Class representing an HTML editor with various functionalities.
 */
export default class HtmlEditor extends Editor {
  /**
   * Queries the commands state of the reference element.
   * @param ref - The HTML element reference.
   * @returns An object containing the command states.
   */
  queryCommands(ref: ExtendedHTMLElement): any {
    return {
      content: ref != null ? ref.innerHTML : null,
      fontName: document.queryCommandValue('fontName'),
      fontSize: document.queryCommandValue('fontSize'),
      formatBlock: document.queryCommandValue('formatBlock'),
      bold: document.queryCommandState('bold'),
      underline: document.queryCommandState('underline'),
      justifyRight: document.queryCommandState('justifyRight'),
      justifyLeft: document.queryCommandState('justifyLeft'),
      justifyCenter: document.queryCommandState('justifyCenter'),
      justifyFull: document.queryCommandState('justifyFull'),
      italic: document.queryCommandState('italic'),
      strikeThrough: document.queryCommandState('strikeThrough'),
      superscript: document.queryCommandState('superscript'),
      subscript: document.queryCommandState('subscript'),
      unlink: document.queryCommandEnabled('unlink'),
      undo: document.queryCommandEnabled('undo'),
      redo: document.queryCommandEnabled('redo')
    };
  }
}